import React, { useEffect, useState } from 'react';
import emptyStateIcon from '../../../../assets/empty-state-icon.svg';

const EmptyProfileState = ({ currentTopicId, categoryType }) => {
  const [mainDescription, setMainDescription] = useState('');

  useEffect(() => {
    switch (categoryType) {
      case 'myArticles': {
        if (currentTopicId) {
          setMainDescription(
            'It looks like the writer hasn’t written any articles yet under this topic yet. But great things are coming! Try exploring other topics and be the first to know by clicking the Follow button.'
          );
        } else {
          setMainDescription(
            'It looks like the writer hasn’t written any articles yet. But great things are coming! Be the first to know by clicking the Follow button.'
          );
        }
        break;
      }
      case 'myComments': {
        setMainDescription(
          `It looks like the author hasn’t left any comments yet, but great things are coming! Be the first to know by clicking the Follow button.`
        );
        break;
      }
      default: {
        setMainDescription(
          'There’s nothing here, but great things are coming! Be the first to know by clicking the Follow button.'
        );
        break;
      }
    }
  }, [categoryType]);

  return (
    <div className="flex flex-col gap-4 items-center">
      <img className="w-[50px] md:w-[40px]" src={emptyStateIcon} alt="" />
      <p className="font-[400] text-md md:text-lg text-center">{mainDescription}</p>
    </div>
  );
};

export default EmptyProfileState;
